var _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10L0.331035 9.25671C0.120321 9.44635 -4.05794e-07 9.71651 -3.93402e-07 10C-3.81011e-07 10.2835 0.120321 10.5537 0.331035 10.7433L1 10ZM11.669 1.74329C12.0795 1.37383 12.1128 0.741544 11.7433 0.331035C11.3738 -0.0794759 10.7415 -0.112753 10.331 0.256706L11.669 1.74329ZM10.331 19.7433C10.7415 20.1128 11.3738 20.0795 11.7433 19.669C12.1128 19.2585 12.0795 18.6262 11.669 18.2567L10.331 19.7433ZM1.66896 10.7433L11.669 1.74329L10.331 0.256706L0.331035 9.25671L1.66896 10.7433ZM11.669 18.2567L1.66896 9.25671L0.331035 10.7433L10.331 19.7433L11.669 18.2567Z",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 10,
    x2: 29,
    y2: 10,
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.69908b245038147f31937474d130e91a.svg";
export { ForwardRef as ReactComponent };